import debug from 'bows';

const log = debug('MobileNav');

export default class {
	constructor( node, opts = {} ) {
		this.node = ( typeof node === 'string' ) ? document.querySelector( node ) : node;
		this.opts = Object.assign( {
			openClass: 'header--open',
			bodyClass: 'fixed',
			opener: '.header__menu-open',
			closer: '.header__menu-close',
			openEvent: 'header.open',
			closeEvent: 'header.close',
		}, opts );

		if ( ! ( this.node instanceof HTMLElement ) ) {
			return;
		}

		this.opened = false;
		this.opener = (typeof this.opts.opener === 'string') ? document.querySelector(this.opts.opener) : this.opts.opener;
		this.closer = (typeof this.opts.closer === 'string') ? document.querySelector(this.opts.closer) : this.opts.closer;

		if ( this.opener instanceof HTMLElement ) {
			this.opener.addEventListener('click', (e) => {
				if ( e && e.preventDefault ) {
					e.preventDefault();
				}
				this.open();
			});
		}

		if ( this.closer instanceof HTMLElement ) {
			this.closer.addEventListener('click', (e) => {
				if ( e && e.preventDefault ) {
					e.preventDefault();
				}
				this.close();
			});
		}
	}

	open() {
		log('open');
		this.opened = true;
		this.node.classList.add(this.opts.openClass);
		document.body.classList.add(this.opts.bodyClass);
		this.node.dispatchEvent(new Event(this.opts.openEvent));
	}

	close() {
		log('close');
		this.opened = false;
		this.node.classList.remove(this.opts.openClass);
		document.body.classList.remove(this.opts.bodyClass);
		this.node.dispatchEvent(new Event(this.opts.closeEvent));
	}

	toggle() {
		log('toggle');
		return this.opened ? this.close() : this.open();
	}
}
